import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import {
  getLocale,
  isDateControl,
  RankedTester,
  rankWith
} from '@jsonforms/core';
import { JsonFormsAngularService, JsonFormsControl } from '@jsonforms/angular';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'DateControlRenderer',
  template: `
    <mat-form-field fxFlex [fxHide]="hidden">
      <mat-label>{{ label }}</mat-label>
      <input
        matInput
        [min]="minDate"
        [max]="maxDate"
        (dateChange)="onChange($event)"
        [id]="id"
        [formControl]="form"
        [matDatepicker]="datepicker"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="datepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #datepicker color="accent"></mat-datepicker>
      <mat-hint *ngIf="shouldShowUnfocusedDescription()">{{ description }}</mat-hint>
      <mat-error>{{ error }}</mat-error>
    </mat-form-field>
  `,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerRenderer extends JsonFormsControl {
  constructor(
    jsonformsService: JsonFormsAngularService,
    private dateAdapter: DateAdapter<NativeDateAdapter>
  ) {
    super(jsonformsService);
  }

  mapAdditionalProps() {
  }

  getEventValue = (event: any) => {
    const newDate = event?.value?.format("YYYY-MM-DD") ?? '';
    return newDate;
  };

  get minDate () {
    const minDate = new Date(2000,0,1);
    if ( this.uischema?.options?.minDate === null || this.uischema?.options?.minDate === undefined ) return minDate;
    return this.uischema?.options?.minDate;
  };


  get maxDate () {
    const maxDate = new Date(2200,11,31);
    if ( this.uischema?.options?.maxDate === null || this.uischema?.options?.maxDate === undefined ) return maxDate;
    return this.uischema?.options?.maxDate;
  };

}

export const DateControlRendererTester: RankedTester = rankWith(
  12,
  isDateControl
);
